<template>
  <div class="twelve columns">
    <el-form-item
      label="Conteúdo"
      prop="conteudo"
    >
      <el-card style="width: 100%; margin-bottom: 20px;">
        <ckeditor
          :model-value="content"
          @update:model-value="(val) => content = val"
          :editor="editor"
          :config="editorConfig"
        />
      </el-card>
    </el-form-item>
  </div>
</template>
<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
  name: 'Editor',
  components: {
    ckeditor: CKEditor.component,
  },
  props: {
    conteudo: {
      type: String,
      required: true,
    },
  },
  emits: ['changeConteudo'],
  data() {
    return {
      editor: Editor,
      editorConfig: { 
        placeholder: 'Digite ou cole o conteúdo aqui',
        title: false,
      },
      content: this.conteudo,
    };
  },
  watch: {
    content: 'update',
    conteudo: 'updateContent',
  },
  mounted() {
    /* eslint-disable no-console */
    console.log(this.editorConfig);
  },
  methods: {
    update() {
      this.$emit('changeConteudo', this.content);
    },
    updateContent() {
      this.content = this.conteudo;
    },
  },
};
</script>
